{
  "title": "Perfil",
  "summary": {
    "title": "Mis datos",
    "name": "Nombre",
    "email": "Correo",
    "role": "Rol",
    "company": "Empresa",
    "noCompany": "Panel de Fermin",
    "scope": "Alcance de sedes",
    "scopeAll": "Toda la empresa",
    "lastLogin": "Último ingreso"
  },
  "roles": {
    "SUPER_ADMIN": "Super Admin",
    "COMPANY_ADMIN": "Administrador de empresa",
    "SITE_MANAGER": "Encargado de sede",
    "VIEWER": "Solo lectura"
  },
  "password": {
    "title": "Cambiar contraseña",
    "description": "Al cambiarla se cierran tus demás sesiones.",
    "current": "Contraseña actual",
    "new": "Nueva contraseña",
    "confirm": "Repite la nueva contraseña",
    "submit": "Cambiar contraseña",
    "changed": "Contraseña actualizada.",
    "wrongCurrent": "La contraseña actual no es correcta."
  },
  "sessions": {
    "title": "Sesiones",
    "description": "Dispositivos con una sesión abierta en Fermin Admin.",
    "device": "Dispositivo",
    "ip": "IP",
    "startedAt": "Inicio",
    "lastSeenAt": "Última actividad",
    "actions": "Acciones",
    "empty": "No hay otras sesiones abiertas.",
    "unknownDevice": "Dispositivo desconocido",
    "closed": "Sesión cerrada.",
    "closeAria": "Cerrar la sesión de {device}",
    "confirmTitle": "¿Cerrar esta sesión?",
    "confirmCurrent": "Es la sesión que estás usando: tendrás que ingresar de nuevo.",
    "confirmOther": "El dispositivo tendrá que ingresar de nuevo.",
    "confirmAction": "Cerrar sesión"
  }
}
